import { ChakraProvider, extendTheme } from "@chakra-ui/react"
import { ReactNode } from "react"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { getChakraTheme } from "../../theme/ChakraThemeProvider"

const syncTheme = {
  colors: {
    backgroundGrayLight: "rgba(26, 32, 44, 0.1)",
    backgroundGrayDark: "rgba(26, 32, 44, 0.33)",
    textOnDark: "rgba(255,255,255, 0.9)",
    textOnLight: "#444",
    meta: "rgba(68, 68, 68, 0.6)"
  },
  radii: {
    card: "10px"
  },
  space: {
    syncSmall: "8px",
    syncMd: "16px",
    syncLarge: "32px",
    syncXLarge: "64px"
  },
  fontSizes: {
    sm: "14px",
    md: "16px",
    lg: "18px"
  }
}

const SyncCardChakraProvider = ({ children }: { children: ReactNode }) => {
  const { school } = usePathwrightContext()
  const baseTheme = getChakraTheme(school)

  const theme = extendTheme(syncTheme, baseTheme)

  return <ChakraProvider theme={theme}>{children}</ChakraProvider>
}

export default SyncCardChakraProvider
